import React, { useState } from 'react';
import './../App.css';
import Button from 'react-bootstrap/Button';
import { Link } from 'react-router-dom';
import {
    StyledAvatar,
    StyledContainer,
    BackgroundImage,
} from "./styled";
import { InstagramEmbed } from 'react-social-media-embed';
import { Card, Col, Row, Modal } from 'react-bootstrap';


function Homepage() {
    const [galleryModalOpen, setGalleryModalOpen] = useState(false)
    const [image, setImage] = useState('')

    const quotes = [
        {
            name: "Elliot",
            quote:
                "Rosita is incredibly inspiring and a credit to the kind of life and mindset that can be forged from an interdisciplinary education.",
        },
        {
            name: "Marcus",
            quote: "Haven't had a learning experience like that pretty much ever!",
        },
        {
            name: "Nina",
            quote:
                "As someone who branded themself not traditionally creative, I fully reject that notion now!",
        },
    ]



    const handleShow = (image: string) => { setGalleryModalOpen(true); setImage(image) }
    const handleClose = () => { setGalleryModalOpen(false) }
    return (
        <div className="App">

            <Modal show={galleryModalOpen} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Gallery</Modal.Title>
                </Modal.Header>
                <Modal.Body><img className='modal-image' src={image} alt={image} /></Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* First load area */}
            <StyledContainer id='home'>
                <BackgroundImage />
            </StyledContainer>
            <section className="text-white d-flex justify-content-center flex-column align-items-center title-banner" id='home'>
                <div className='p-3 d-flex justify-content-center flex-column align-items-center'>
                    <h1>Mindful Making for Creative Souls</h1>
                    <p><strong>
                        Join cozy creative sessions & learn to make beautiful things by hand - no experience needed
                    </strong>
                    </p>
                    <div className='d-flex gap-3'>

                        <Button href='#contact' size='lg' variant="secondary">Enquire now</Button>
                        <Link to="/workshops">
                            <Button size='lg' variant="warning">Workshops</Button>
                        </Link>
                    </div>
                </div>
            </section>

            <section className="section offerings text-center offerings-grid">
                <div className="offerings-intro">
                    <h2>
                        Slow down and make something to be proud of. Our workshops offer the revitalising opportunity to reconnect to the creator within.
                        <span className='capitalised'>
                        </span>
                    </h2>
                </div>

                <div className="offerings-intro-more">
                    Having an understanding of our material world in both the creative and scientific sense is a true gift. Learn the art and science of the stuff around us from a university level lecturer and maker and treat your self.
                </div>

                <div className='rectangle'></div>
                <div className='circle-1'></div>
                <div className='circle-2'></div>
                <div className="offerings-description-1">
                    If you are a total beginner or maybe rekindling an old hobby, these calm sessions offer an introduction to your chosen making method and offer a break from the busyness of life and technology. Come back to basics and create with us.
                </div>
                <div className="offerings-description-2">
                    Our workshops and retreats are perfect for gatherings, parties, and any other wholesome get together. You can book as either a group or an individual, which is great to meet people in your local area too.
                </div>
                <div className="offerings-image">
                    <img src={'/images/signature.png'} alt="signature" />
                </div>
            </section>

            <StyledContainer>
                <section className='about-our-workshops p-4' id='about'>
                    <h2>About Our Workshops</h2>
                    <div className="cell-1 cell-layout">
                        <img src={'/images/nads.jpeg'} alt='blacksmithing' />
                        <h3>Macramé Hanger Workshops</h3>
                        <p>
                            Knotting is one of the most ancient crafts on earth. Spend the day enjoying the slow making method of macrame. Using natural rope we will create your perfect plant hanger learning knots and techniques which you can carry forward into your future macrame projects.
                        </p>
                    </div>
                    <div className='cell-2 cell-layout' >
                        <img src={'/images/linkedhearts.png'} alt='blacksmithing' />
                        <h3>Try the ancient art of Blacksmithing</h3>
                        <p>Enjoy an afternoon away from screens and every day life, and visit us in the forge. Come with an idea in mind, or follow our suggestions and create a totally bespoke, impressive steel forged item which will impress all your friends and family. Small groups of 6 people maximum will be part of this workshop, bring a lunch and some sturdy clothes which will undoubtedly get messy and get stuck in and make memories to tell at the dinner parties.</p>

                    </div>
                    <div className='cell-3 cell-layout' >
                        <img src={'/images/macrame_bag.png'} alt='macrame' />
                        <h3>Macramé Mini Bag</h3>
                        <p>
                            Follow along and enjoy the meditative process of knotting your own bag from scratch. All levels welcome.
                        </p>
                    </div>
                    <div className='cell-4 cell-layout' >
                        <img src={'/images/knithands.png'} alt='knitting' />
                        <h3>Intro to Knitting</h3>
                        <p>Missed out on learning to knit previously? Our calm and inclusive workshops will teach you all the basics from casting on, knit, purl and casting off.
                        </p>
                    </div>
                    <div className='cell-5 cell-layout'>
                        <img src={'/images/wallhanger.png'} alt='wallhanger' />
                        <h3>Macramé Wall Hanging</h3>
                        <p>
                            Learn how to create a beautiful wall hanging using your knot knowledge, or learn from scratch. All levels welcome.
                        </p>
                    </div>
                    {/* <div className='cell-5 cell-layout'>
                    <img src={wood} alt='woodwork' />
                    <h3>Carve your own spatula from natural wood</h3>
                    <p>
                        Get your crafting hat on and learn not only how to carve a beautiful spatula from a tree trunk, but learn all about wood in the process. This workshop will give you the knowledge of grain direction in wood, inform you about what greenwood actually is, and give you knife skills which you can carry with you in life. Be careful though, you might catch the wood working bug…
                    </p>
                </div> */}
                    <div className='cell-6 cell-layout'>
                        <img src={'/images/pottery.png'} alt='pottery' />
                        <h3>Pottery Introduction</h3>
                        <p>Learn the zen art of throwing pottery and get close up with clay. This workshop will introduce you to both pinch pots and also throwing on the pottery wheel. Take home 2 cups or pots with you which you will cherish, as well as learning the skills of how to prepare, handle and craft with clay.
                        </p>
                    </div>
                </section>
            </StyledContainer>

            {/* About */}
            <StyledContainer className='p-4'>
                <Row>
                    <Col className='d-flex justify-content-center flex-column align-items-center' style={{ textAlign: "justify" }}>
                        <h2 className="text-2xl font-semibold text-center my-4">About Rosita</h2>

                        <StyledAvatar src={'/images/rosita.png'} alt='Avatar' fluid />
                        <p><strong>Lecturer · Maker · Material Scientist</strong></p>
                        <p>
                            Rosita is a maker, educator, and material scientist with a deep belief in the power of hands-on creativity.
                        </p>
                        <p>
                            After earning a high distinction in Art Foundation, she went on to study Arts and Sciences at UCL, majoring in Chemistry and Materials Science. Her interdisciplinary path also led her to China for a year, where she immersed herself in Mandarin and new ways of thinking and learning. Her research has taken her to Korea with the Global Cultural Forum where she was part of a chosen team to implement important public artwork.
                        </p>
                        <p>
                            Alongside teaching herself to code and working in tech, Rosita continued her creative practice — exploring stone carving, carpentry, blacksmithing, and traditional crafts. This dual life between the analytical and the tactile shaped her unique approach to making.</p>
                        <p>
                            At the cutting edge new university, the London Interdisciplinary School (LIS), Rosita designed and led a highly praised course that combined material science with traditional craft. The course became a favourite among students for its thoughtful, grounding, and joyful approach to learning through the hands.</p>
                        <p>
                            At the heart of Rosita’s work is a belief in the therapeutic power of making — as a way to support mental wellbeing and rekindle our relationship with the material world.
                        </p>
                        <p>
                            Now, Rosita is bringing that experience beyond the university — offering inclusive, accessible workshops across London, Kent, and Sussex. Her sessions welcome all skill levels and focus on reconnecting with materials, process, and presence — one mindful, creative moment at a time.</p>
                    </Col>
                </Row>
            </StyledContainer>
            <section className="section container d-flex justify-content-center" id='gallery'>
                <div className="gallery w-md-50 align-items-center">
                    <h2 className="font-semibold text-center m-1 my-md-4 gallery-text">Gallery</h2>
                    <div onClick={() => handleShow('/images/macrame_mat.png')} className="image-1" >  <img style={{ objectFit: 'cover', width: '100%', height: '100%', borderRadius: '0.4rem' }} src={'/images/macrame_mat.png'} alt='macrame' /></div>
                    <div onClick={() => handleShow('/images/hot.png')} className="image-2">  <img style={{ objectFit: 'cover', width: '100%', height: '100%', borderRadius: '0.4rem' }} src={'/images/hot.png'} alt='wallhanging' /></div>
                    <div onClick={() => handleShow('/images/market.jpg')} className="image-3">  <img style={{ objectFit: 'cover', width: '100%', height: '100%', borderRadius: '0.4rem' }} src={'/images/market.jpg'} alt='macrame hanging basket' /></div>
                    <div onClick={() => handleShow('/images/anglegrinder.png')} className="image-4" >  <img style={{ objectFit: 'cover', width: '100%', height: '100%', borderRadius: '0.4rem' }} src={'/images/anglegrinder.png'} alt='blacksmithing' /></div>
                    <div onClick={() => handleShow('/images/crochet1.png')} className="image-5">  <img style={{ objectFit: 'cover', width: '100%', height: '100%', borderRadius: '0.4rem' }} src={'/images/crochet1.png'} alt='blacksmith class' /></div>
                    <div onClick={() => handleShow('/images/macrame_cat.png')} className="image-6">  <img style={{ objectFit: 'cover', width: '100%', height: '100%', borderRadius: '0.4rem' }} src={'/images/macrame_cat.png'} alt='macrame cat' /></div>
                    <div onClick={() => handleShow('/images/linkedhearts.png')} className="image-7">  <img style={{ objectFit: 'cover', width: '100%', height: '100%', borderRadius: '0.4rem' }} src={'/images/linkedhearts.png'} alt='macrame cat' /></div>
                </div>
            </section>

            <section className="my-5">
                <h2 className="text-center mb-3">Where We're Based</h2>
                <p className="text-center text-muted mb-4">
                    We run workshops in North London (Alexandra Palace), as well as across Kent and Sussex.
                </p>

                <div className='d-md-flex justify-content-center gap-2'>
                    <div className="d-flex justify-content-center">
                        <iframe
                            title="Rosita Location Map"
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d19844.221194413768!2d-0.1469017!3d51.5932686!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48761bb9e2a9c3f7%3A0x9dba1761c7e10a9e!2sAlexandra%20Palace!5e0!3m2!1sen!2suk!4v1720100000000"
                            width="100%"
                            height="350"
                            style={{ border: 0, maxWidth: '800px', borderRadius: '1rem' }}
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                        ></iframe>
                    </div>

                    {/* East Sussex Map */}
                    <div className="mb-4 d-flex justify-content-center">
                        <div style={{ width: '100%', maxWidth: '800px', borderRadius: '1rem', overflow: 'hidden' }}>
                            <iframe
                                title="East Sussex Map"
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d502749.75844034276!2d0.06052053972894909!3d50.93374465920673!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47df0ba0c88c46e7%3A0xa07d279804c1a7!2sEast%20Sussex!5e0!3m2!1sen!2suk!4v1720101111111"
                                width="100%"
                                height="350"
                                style={{ border: 0 }}
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                            ></iframe>
                        </div>
                    </div>
                </div>
            </section>

            <section className="section testimonial">
                <h2 className="text-2xl font-semibold text-center my-4">What People Are Saying</h2>
                <div className="d-flex flex-column p-2 flex-md-row gap-3">
                    {quotes.map((quote, idx) => (
                        <Col key={quote.name}>
                            <Card
                                key={quote.name + idx}
                                className="border-0 shadow-sm rounded p-3 flex-fill"
                                style={{ backgroundColor: '#fdf7f0' }}
                            >
                                <Card.Body>
                                    <p className="fs-5 fw-light mb-2">{quote.quote}</p>
                                    <footer className="blockquote-footer my-2">{quote.name}</footer>
                                </Card.Body>
                            </Card>
                        </Col>

                    ))}
                </div>
            </section>
            <section className="row section subscribe d-flex justify-content-center flex-row align-items-center" id='contact' style={{ minHeight: '70vh' }}>

                <div className='flex-grow-1 col-12 col-md-6'>
                    <h3>Stay in Touch and For Bookings</h3>
                    <div>
                        Email: <a href='mailto:hello@madebyrosita.com?subject=Enquiry to make!'>hello@madebyrosita.com</a>
                    </div>
                </div>
                <div className='flex-grow-1 col-12 col-md-6 p-0 p-md-1'>
                    <h3>Or connect on Instagram</h3>
                    <InstagramEmbed url="https://www.instagram.com/made_by_rosita/" />
                </div>
            </section>
        </div >
    );
}

export default Homepage;
